if (!customElements.get('hubspot-mail')) {
  class HubspotMail extends HTMLElement {
    constructor() {
      super();
      this.region = this.getAttribute('data-region');
      this.portalId = this.getAttribute('data-portalId');
      this.formId = this.getAttribute('data-formId');
    }
    connectedCallback() {
      this.init();
    }
    populateField($form) {
      const urlPath = new URL(window.location.href);
      $form.querySelector('input[type="email"').focus();
      $form.querySelector('input[type="email"').value = urlPath.searchParams.get('contact[email]');
    }
    hubspotForm() {
      const obj = this;
      hbspt.forms.create({
        region: this.region,
        portalId: this.portalId,
        formId: this.formId,
        cssClass: 'newsletter-page_form customer',
        submitButtonClass: 'theme_cta theme_cta_primary--dark',
        onFormReady: function ($form) {
          obj.populateField($form);
        },
      });
    }
    init() {
      this.hubspotForm();
    }
  }
  customElements.define('hubspot-mail', HubspotMail);
}
